<template>
  <v-container grid-list-md text-xs-center >
    <v-layout row wrap >
      <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-card dark color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">add/remove color</h3>
              <div>Click to toggle between colorized isochronic maps or greyscale-inverted isochronic maps. The inverted-greyscale maps better highlight areas reachable in a given amount of time whereas colorized maps better highlight gradations of time and can be very aesthetically pleasing. Also, some basemaps look much better either colorized or with greyscale-inversion.</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-list>
            <v-btn
              large
              color="grey"
              @click="twoTone(true)"
            >
              Invert
            </v-btn>
            <v-btn
              large
              color="red"
              @click="twoTone(false)"
            >
              Colorize
            </v-btn>
            </v-list>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs4></v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    data () {
      return {
        dialog: true
      }
    },
    computed: {
      setPixel () {
        return this.$store.getters.pixel
      }
    },
    methods: {
      twoTone (payload) {
        this.$store.dispatch('twoTone', payload)
        this.$router.push('/')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/toolBox/inverter.vue